import { render, staticRenderFns } from "./EditItemtable.vue?vue&type=template&id=59d1774a&scoped=true"
import script from "./EditItemtable.vue?vue&type=script&lang=js"
export * from "./EditItemtable.vue?vue&type=script&lang=js"
import style0 from "./EditItemtable.vue?vue&type=style&index=0&id=59d1774a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d1774a",
  null
  
)

export default component.exports